import { doodBlockConfig } from "./dood-block-config";
import type { IBlockDescriptor } from "./descriptor";

export type ChecksPagePreviewItem = {
  id: string;
  name: string;
  price: number;
  description: string;
  selected_by: {
    user: string;
    transaction: string;
  };
};

export type ChecksPagePreviewCheck = {
  id: string;
  closed_at: string;
  opened_at: string;
  items: readonly ChecksPagePreviewItem[];
  transactions: readonly unknown[];
  shop: {
    id: string;
    name: string;
    current_user_roles: readonly unknown[];
  };
  marketplace: {
    id: string;
    name: string;
    current_user_roles: readonly unknown[];
  };
  onsite_location: {
    id: string;
    name: string;
  };
  final_price: number;
  outstanding_amount: number;
  available_payment_methods: readonly unknown[];
  currency: string;
};

/** Serializable preview VM for `ChecksPageBlockComponent`. */
export type ChecksPageBlockScenarioContent = {
  checks: readonly ChecksPagePreviewCheck[];
  isChecksLoading: boolean;
};
const {
  checksPageBlockDescriptor: _generatedChecksPageBlockDescriptor,
  checksPageBlockBlocDefinition,
  checksPageBlockDashboardLayout,
  checksPageBlockConfig,
  checksPageBlockResolveConfig,
  checksPageBlockProperties,
  checksPageBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    id: 'checks-block',
    name: 'Checks',
    componentType: 'ChecksPageBlockComponent',
    category: 'content',
    description: 'List of current checks for the authenticated user.',
    keywords: ['checks', 'payments', 'pay-at-table'],
    allowed_in: ['ChecksPage'],
    hideFromPicker: true,
    sharedFields: {},
  },
  () => ({}),
  () => 'displayAll'
);

export function checksPageBlockDescriptor(): IBlockDescriptor {
  return _generatedChecksPageBlockDescriptor;
}

export {
  checksPageBlockBlocDefinition,
  checksPageBlockDashboardLayout,
  checksPageBlockConfig,
  checksPageBlockResolveConfig,
  checksPageBlockProperties,
  checksPageBlockDefinitionSetupScenarios,
};

export type ChecksPageBlockConfig = typeof checksPageBlockConfig;
